import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ArrowMoveUp = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="m7.28 3.797-2.17 2.17-.943-.942 3.771-3.772 3.771 3.772-.943.942-2.153-2.153v5.448H7.28V3.797Zm0 10.799v-1.334h1.333v1.334H7.28Zm0-2V9.929h1.333v2.667H7.28Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default ArrowMoveUp;
